// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"ca6a8f9e","74":"a8e308ee","200":"8d77c890","260":"b126441b","400":"fcd2e0fc","420":"2eb41076","498":"9ee36872","905":"81466e6b"}[chunkId] + ".chunk.js";
};